export default __webpack_public_path__ + "static/media/edit.c381604a.svg";